/* eslint-disable */
import { useMemo } from 'react';
import { useQuery } from 'react-query';
import {
  getDashboardGraph,
  getTopMaskNames,
  getTopTenSubs,
  getTotalInteg,
  getTotalMasks,
  getTotalMsgs,
  getTotalOrgs,
  getTotalTxnAndCol,
} from './actions';

const type = {
  hour: 'DAILY',
  day: 'MONTHLY',
  month: 'YEARLY',
};

export const useTransactionHistogram = (filter) => {
  const params = useMemo(
    () => ({
      date_from: filter?.from,
      date_to: filter?.to,
      type: type[filter?.type],
    }),
    [filter],
  );

  const { data: raw, isLoading } = useQuery({
    queryKey: ['get-dashboard-main-graph', params],
    queryFn: getDashboardGraph,
    retry: true,
    keepPreviousData: false,
  });
  const data = raw?.data?.data;
  const { table, chart } = useMemo(() => {
    const tableData = (data || []).map((x) => ({
      id: x.label,
      name: x.label,
      messages: x.count,
    }));
    const chartData = (data || []).map((x) => ({
      id: x.label,
      title: x.label,
      count: x.count,
    }));
    return {
      table: tableData,
      chart: chartData,
    };
  }, [data]);
  return [isLoading, table, chart];
};

export const useHorizontalBar = (filter) => {
  const params = useMemo(
    () => ({
      date_from: filter?.from,
      date_to: filter?.to,
      type: type[filter?.type],
    }),
    [filter],
  );

  const { data: raw, isSubsLoading } = useQuery({
    queryKey: ['get-top-ten-subscribers', params],
    queryFn: getTopTenSubs,
    retry: false,
    keepPreviousData: false,
  });
  const { data: summaryRaw, isSummaryLoading } = useQuery({
    queryKey: ['get-summary-data'],
    queryFn: getTotalTxnAndCol,
    retry: false,
    keepPreviousData: false,
  });
  const isLoading = isSubsLoading || isSummaryLoading;
  const data = raw?.data?.data;
  const summaryData = summaryRaw?.data?.data;
  const { chart, summary } = useMemo(() => {
    const chartData = (data || []).map((x) => ({
      id: x.organization_name,
      title: x.organization_name,
      count: x.collections,
    }));
    return {
      chart: chartData,
      summary: {
        count: summaryData?.total_transaction,
        amount: summaryData?.total_collection,
      },
    };
  }, [data, summaryData]);
  return [isLoading, '', chart, '', summary];
};

export const usePieChart = (filter) => {
  const params = useMemo(
    () => ({
      date_from: filter?.from,
      date_to: filter?.to,
      type: type[filter?.type],
    }),
    [filter],
  );
  const { data: raw, isLoading } = useQuery({
    queryKey: ['get-top-mask-names', { ...params, size: 10 }],
    queryFn: getTopMaskNames,
    retry: false,
    keepPreviousData: false,
  });
  const data = raw?.data?.data;
  return [isLoading, '', data];
};

export const useTopOrg = () => {
  const isLoading = false;
  const { data: list } = subscribers;
  return [isLoading, list];
};

export const useTotalMsgs = () => {
  const { data: raw, isLoading } = useQuery({
    queryKey: ['get-total-msgs'],
    queryFn: getTotalMsgs,
    retry: true,
    keepPreviousData: true,
  });
  const data = raw?.data?.data;
  return [isLoading, data];
};

export const useTotalOrgs = () => {
  const { data: raw, isLoading } = useQuery({
    queryKey: ['get-total-orgs'],
    queryFn: getTotalOrgs,
    retry: false,
    keepPreviousData: true,
  });
  const data = raw?.data?.data;
  return [isLoading, data];
};

export const useTotalInteg = () => {
  const { data: raw, isLoading } = useQuery({
    queryKey: ['get-total-integrations'],
    queryFn: getTotalInteg,
    retry: false,
    keepPreviousData: true,
  });
  const data = raw?.data?.data;
  return [isLoading, data];
};

export const useTotalMasks = () => {
  const { data: raw, isLoading } = useQuery({
    queryKey: ['get-total-masks'],
    queryFn: getTotalMasks,
    retry: false,
    keepPreviousData: true,
  });
  const data = raw?.data?.data;
  return [isLoading, data];
};
